import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">TRANSPORTATION</h2>
						<div className="red-border"> </div>
						<p>Our innovation-driven, robust and highly scalable IT solutions helps transform businesses working in the logistics domain.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
